import { AuxiliumComponent } from "../auxilium-component";

export class Form extends AuxiliumComponent {
	#DefaultOptions = {
		ProcessCheckboxes: true
	}

	reportValidity() {
		const validity = [...this.querySelectorAll("chip-input, chip-textarea, chip-dropdown, chip-select, chip-checkbox") ?? []].filter(x => !x.reportValidity()).length === 0,
			tab = this.closest(".tab-group__tab");

		if (tab) {
			const index = [...tab.parentElement.children].indexOf(tab),
				group = tab.closest("chip-tabgroup");

			if (!validity) {
				group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.add("step__invalid");
			} else if (!tab.querySelector(".input-field__invalid")) {
				group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.remove("step__invalid");
			}
		}

		return validity;
	}

	checkValidity() {
		const validity = [...this.querySelectorAll("chip-input, chip-textarea, chip-dropdown, chip-select, chip-checkbox") ?? []].filter(x => !x.checkValidity()).length === 0,
			tab = this.closest(".tab-group__tab");

		if (tab) {
			const index = [...tab.parentElement.children].indexOf(tab),
				group = tab.closest("chip-tabgroup");

			if (validity) {
				group.querySelector(`:scope > .tab-group__tabs > .tab__wrapper > chip-tab:nth-child(${index + 1})>button`)?.classList.remove("step__invalid");
			}
		}

		return validity;
	}

	getData(options = this.#DefaultOptions) {
		const elements = this.querySelectorAll("chip-input[name], chip-textarea[name], chip-dropdown[name], chip-select[name], chip-radio[name][checked], chip-checkbox[name][checked]") ?? [];

		if (!elements.length) {
			return {};
		}

		return Object.assign(...[...elements].
			map(x => {
				let value = x.value;
				if (x.nodeName === "CHIP-CHECKBOX" && options.ProcessCheckboxes && value === "true") { value = true; }

				return { [x.name]: value };
			}));
	}
}